module.exports = __webpack_public_path__ + "img/graphryder.b173d57d.png";